var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148.87 168.09",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.45 125.19a3.86 3.86 0 01-1.25-3c0-16.64.24-33.3-.17-49.93-.35-14.33-5.92-26.69-15.82-37A55.14 55.14 0 0089.31 20a2.1 2.1 0 01-1.83-2.49 28.94 28.94 0 00-.36-7c-1.25-5.39-4.78-8.73-10-10.18l-.6-.19a2.33 2.33 0 00-.78-.14h-2.69a2.35 2.35 0 00-.64.09 15.42 15.42 0 00-7.34 4.12 13.86 13.86 0 00-3.74 10.06c0 1.66.52 3.76-.27 4.87s-2.93 1.14-4.46 1.7c-20.68 7.59-33.61 22.1-38 44a60.66 60.66 0 00-.91 11.67c-.1 15.21-.06 30.41 0 45.62a3.85 3.85 0 01-1.24 3c-5.32 5.34-10.55 10.68-15.8 16A2.21 2.21 0 000 142.7v5.54a2.22 2.22 0 002.19 2.23h52.18a2.26 2.26 0 012.23 2 17.83 17.83 0 005.63 10.74 20.59 20.59 0 009.5 4.82 2.22 2.22 0 00.57.07H77a1.54 1.54 0 01.44-.26A18.09 18.09 0 0091 157.37a15.31 15.31 0 001.49-5 2.21 2.21 0 012.22-1.95h52a2.23 2.23 0 002.2-2.23v-5.49a2.25 2.25 0 00-.65-1.57c-5.26-5.32-10.53-10.66-15.81-15.94z",
    fill: "#fca943",
    "data-name": "Capa 2"
  })));
}

export default SvgNotification;